"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactElement } from "react";
import { lazy, Suspense, useEffect } from "react";

import { useTranslations } from "@rootreeweb/react-translations";

import { ORGID } from "../lib/index.js";

type Props = {
	translations: Record<string, string>;
};

export const App = (props: Props): ReactElement => {
	const { translations } = props;
	const queryClient = new QueryClient();

	const Widget = lazy(() => import("./ImpactReport.js"));

	const { setTranslations } = useTranslations();
	useEffect(() => {
		setTranslations(translations);
	}, [setTranslations, translations]);

	return (
		<QueryClientProvider client={queryClient}>
			<Suspense
				fallback={
					<div className={"ih:flex ih:w-full ih:justify-center ih:p-4"}>
						<h1>Loading...</h1>
					</div>
				}
			>
				<Widget orgId={ORGID} />
			</Suspense>
		</QueryClientProvider>
	);
};
